var exports = {
  "kL": "GroupedVoiceParticipant.module__container___Z3pHX2",
  "AG": "GroupedVoiceParticipant.module__participantButton___Z3pHX2",
  "IT": "GroupedVoiceParticipant.module__participantButtonSpeaking___Z3pHX2",
  "O": "GroupedVoiceParticipant.module__participantButtonContextMenuActive___Z3pHX2",
  "SX": "GroupedVoiceParticipant.module__avatarAndName___Z3pHX2",
  "VW": "GroupedVoiceParticipant.module__nameContainer___Z3pHX2",
  "F8": "GroupedVoiceParticipant.module__participantName___Z3pHX2",
  "xr": "GroupedVoiceParticipant.module__participantNameSpeaking___Z3pHX2",
  "S$": "GroupedVoiceParticipant.module__participantNameCurrent___Z3pHX2",
  "u$": "GroupedVoiceParticipant.module__deviceCountButton___Z3pHX2",
  "g0": "GroupedVoiceParticipant.module__iconsAndToggle___Z3pHX2",
  "pP": "GroupedVoiceParticipant.module__devicesContainer___Z3pHX2",
  "nt": "GroupedVoiceParticipant.module__flexShrinkZero___Z3pHX2",
};

module.exports = exports;
